import React from 'react';

import { useDemoCompaniesId } from 'src/hooks/demoDashboardMode';
import { useCurrentUserEmployer } from 'src/hooks/employer';
import { useCurrentUserPeo } from 'src/hooks/peo';
import { useCurrentUserPeoPayrollProvider } from 'src/hooks/peoPayrollProvider';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { DemoDashboardScale } from 'src/utils/dashboard/demoDashboardData';
import { isDemoCompanyEnabled } from 'src/utils/demoDashboardMode';

export const useDemoDashboard = (employerIds: string[]) => {
  const { isEmployerAdmin, hasPeoRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();
  const { employer } = useCurrentUserEmployer();
  const { peo } = useCurrentUserPeo();
  const { peoPayrollProvider } = useCurrentUserPeoPayrollProvider();
  const { demoCompaniesId } = useDemoCompaniesId();

  return React.useMemo(() => {
    const isPeoScale = employerIds.length === 0;
    let isDemoDashboardEnabled = false;
    let scale: DemoDashboardScale = 'employer';

    if (isEmployerAdmin && isDemoCompanyEnabled(demoCompaniesId, 'employers', employer?.id)) {
      isDemoDashboardEnabled = true;
      scale = 'employer';
    } else if (hasPeoRoles && isDemoCompanyEnabled(demoCompaniesId, 'peos', peo?.id)) {
      isDemoDashboardEnabled = true;
      scale = isPeoScale ? 'peo' : 'employer';
    } else if (
      isPeoPayrollProviderUser &&
      isDemoCompanyEnabled(demoCompaniesId, 'peoPayrollProviders', peoPayrollProvider?.id)
    ) {
      isDemoDashboardEnabled = true;
      scale = isPeoScale ? 'peo' : 'employer';
    }

    return { isDemoDashboardEnabled, scale };
  }, [
    demoCompaniesId,
    employer?.id,
    employerIds.length,
    hasPeoRoles,
    isEmployerAdmin,
    isPeoPayrollProviderUser,
    peo?.id,
    peoPayrollProvider?.id,
  ]);
};
